import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTick } from '@wojtekmaj/react-hooks';

import { toShortId } from '@rewardopl/utils/short_id';
import { stringify } from '@rewardopl/utils/url';

import { CodeWrapper, ShortId, Wrapper } from './dynamic_code.styles';

import { currentUserIdState } from '../../store';

type DynamicCodeProps = {
  color?: string;
  displayShortId?: boolean;
};

export default function DynamicCode({ color = 'black', displayShortId = true }: DynamicCodeProps) {
  useTick(30000);
  const currentUserId = useAtomValue(currentUserIdState);
  const [previousKey, setPreviousKey] = useState<number>();

  const shortId = toShortId(currentUserId);

  const now = new Date();
  // Round down to the nearest 30 seconds
  now.setSeconds(now.getSeconds() - (now.getSeconds() % 30), 0);

  const key = now.getTime();

  const src = `/api/users/current/qr.svg${stringify({
    bgColor: 'transparent',
    fgColor: color,
  })}`;

  const shouldShowPreviousCode = previousKey && key !== previousKey;

  return (
    <Wrapper>
      <CodeWrapper>
        <img
          alt="QR code"
          height="25"
          key={key}
          onLoad={() => {
            setPreviousKey(key);
          }}
          src={src}
          style={shouldShowPreviousCode ? { display: 'none' } : undefined}
          width="25"
        />
        {shouldShowPreviousCode ? (
          <img alt="QR code" height="25" key={previousKey} src={src} width="25" />
        ) : null}
      </CodeWrapper>
      {displayShortId ? <ShortId>{shortId}</ShortId> : null}
    </Wrapper>
  );
}
